/**
 * 指定の項目と値が同じ
 * @param text
 * @param targetFieldName
 * @returns {function(*, *): string}
 */
export const isConfirm = (text, targetFieldName) => (value, allValues) => value === allValues[targetFieldName] ? '' : text;
